import { useEffect } from "react";
import TextPageNavigation from "../components/TextPageNavigation";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="text-page">
      <div className="container">
        <div className="flex">
          <TextPageNavigation activePage="terms" />
          <div className="text-page-content">
            <div>
              <h1>BackToReality: Website Terms of Use and Purchase</h1>
              <p>
                Welcome to BackToReality! These Terms of Use and Purchase ("
                <strong>Terms</strong>") govern your access to and use of the
                BackToReality website and services (collectively, the "
                <strong>Services</strong>"). By accessing or using our Services,
                you agree to be bound by these Terms. If you do not agree to all
                of these Terms, please do not use our Services.
              </p>
            </div>
            <div className="text-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By using the BackToReality Services, you affirm that you are of
                legal age to enter into this agreement, or have obtained
                parental or guardian consent if you are a minor in your
                jurisdiction. You also agree to comply with all applicable laws
                and regulations regarding your use of the Services.
              </p>
            </div>
            <div className="text-section">
              <h2>2. Changes to Terms</h2>
              <p>
                We reserve the right to modify or update these Terms at any
                time. We will notify you of any significant changes by posting
                the updated Terms on our website. Your continued use of the
                Services after such changes constitutes your acceptance of the
                new Terms. We encourage you to review these Terms periodically.
              </p>
            </div>
            <div className="text-section">
              <h2>3. Our Products and Services</h2>
              <p>
                At BackToReality, we aim to provide insightful tools, but it's
                crucial to understand their limitations and intended use.{" "}
                <strong>
                  Please read the following disclaimers carefully:
                </strong>
              </p>
              <p>
                We make no claims or guarantees about any emotional, health, or
                commercial benefits from using our Services or the information
                on our Website. The information we provide is not a substitute
                for professional medical or psychiatric advice. If you have
                concerns about your health or mental well-being, we strongly
                advise you to consult your doctor.
              </p>
              <p>
                <strong>Specifically:</strong>
              </p>
              <p>
                Our Services are designed solely for information and
                entertainment purposes, not for any type of assessment,
                including medical or psychological assessment. They are for your
                personal use only and should not be used to screen, assess, or
                evaluate others.
              </p>
              <p>
                Our Services should not be seen as, or relied upon as, a
                comprehensive or entirely accurate opinion or assessment. If
                concerns arise from your use of our Services, you should seek
                appropriate professional advice.
              </p>
              <p>
                Any decisions you make after using or reading the content of our
                Services are yours alone, and we will not be liable for the
                consequences of those decisions.
              </p>
              <p>
                Our Services are intended for personal use only and are not
                meant for any business, educational, employment, or recruitment
                context.
              </p>
              <p>
                While we offer our Services in languages other than English, we
                cannot guarantee the accuracy of these translations. Use
                translated versions at your own risk.
              </p>
            </div>
            <div className="text-section">
              <h2>4. Account Registration and Security</h2>
              <p>
                To access certain features of our Services, you may need to
                create an account. You agree to:
              </p>
              <ul>
                <li>
                  Provide accurate, current, and complete information during
                  registration.
                </li>
                <li>
                  Maintain the confidentiality of your account password and be
                  responsible for all activities that occur under your account.
                </li>
                <li>
                  Notify us immediately of any unauthorized use of your account
                  or any other breach of security.
                </li>
                <li>
                  You are solely responsible for all content you submit or
                  transmit through your account.
                </li>
              </ul>
            </div>
            <div className="text-section">
              <h2>5. User Conduct and Content</h2>
              <p>You agree to use the Services responsibly and not to:</p>
              <ul>
                <li>
                  Upload, post, or transmit any content that is unlawful,
                  harmful, threatening, abusive, harassing, defamatory, vulgar,
                  obscene, libelous, invasive of another's privacy, hateful, or
                  racially, ethnically, or otherwise objectionable.
                </li>
                <li>
                  Impersonate any person or entity or falsely state or otherwise
                  misrepresent your affiliation with a person or entity.
                </li>
                <li>
                  Interfere with or disrupt the Services or servers or networks
                  connected to the Services.
                </li>
                <li>
                  Violate any applicable local, national, or international law.
                </li>
                <li>
                  Reproduce, duplicate, copy, sell, resell, or exploit any
                  portion of the Services, use of the Services, or access to the
                  Services without express written permission from us.
                </li>
              </ul>
              <p>
                All content you submit to the Services remains your
                responsibility. By submitting content, you grant BackToReality a
                worldwide, non-exclusive, royalty-free, perpetual, irrevocable,
                and fully sublicensable right to use, reproduce, modify, adapt,
                publish, translate, create derivative works from, distribute,
                and display such content throughout the world in any media.
              </p>
            </div>
            <div className="text-section">
              <h2>6. Intellectual Property Rights</h2>
              <p>
                All content on the BackToReality website, including text,
                graphics, logos, images, audio clips, digital downloads, and
                data compilations, is the property of BackToReality or its
                content suppliers and protected by international copyright laws.
                The compilation of all content on this site is the exclusive
                property of BackToReality and protected by international
                copyright laws.
              </p>
              <p>
                Your use of the Services grants no rights to you in relation to
                our intellectual property or the intellectual property of third
                parties.
              </p>
            </div>
            <div className="text-section">
              <h2>7. Purchases and Payments</h2>
              <ul>
                <li>
                  <strong>Product/Service Descriptions:</strong> We strive to be
                  as accurate as possible in the descriptions of our products
                  and services. However, we do not warrant that product
                  descriptions or other content of our Services are accurate,
                  complete, reliable, current, or error-free.
                </li>
                <li>
                  <strong>Pricing:</strong> All prices for products and services
                  are subject to change without notice.
                </li>
                <li>
                  <strong>Payment:</strong> We use third-party payment
                  processors to facilitate purchases. By making a purchase, you
                  agree to their terms and conditions. We are not responsible
                  for any issues arising from your transaction with these
                  third-party processors.
                </li>
                <li>
                  <strong>Refunds/Cancellations:</strong> All sales are final.
                  No refunds will be issued once a purchase is completed. In
                  exceptional circumstances, please contact us at
                  support@backtoreality.com to discuss."
                </li>
              </ul>
            </div>
            <div className="text-section">
              <h2>8. Disclaimers and Limitation of Liability</h2>
              <p>
                THE SERVICES AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS
                (INCLUDING SOFTWARE) AND OTHER SERVICES INCLUDED ON OR OTHERWISE
                MADE AVAILABLE TO YOU THROUGH THE SERVICES ARE PROVIDED BY
                BACKTOREALITY ON AN "AS IS" AND "AS AVAILABLE" BASIS, UNLESS
                OTHERWISE SPECIFIED IN WRITING. BACKTOREALITY MAKES NO
                REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED,
                AS TO THE OPERATION OF THE SERVICES, OR THE INFORMATION,
                CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER
                SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH
                THE SERVICES, UNLESS OTHERWISE SPECIFIED IN WRITING. YOU
                EXPRESSLY AGREE THAT YOUR USE OF THE SERVICES IS AT YOUR SOLE
                RISK.
              </p>
              <p>
                TO THE FULL EXTENT PERMISSIBLE BY LAW, BACKTOREALITY DISCLAIMS
                ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED
                TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
                PARTICULAR PURPOSE. BACKTOREALITY DOES NOT WARRANT THAT THE
                SERVICES, INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING
                SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE
                AVAILABLE TO YOU THROUGH THE SERVICES, OUR SERVERS, OR
                ELECTRONIC COMMUNICATIONS SENT FROM BACKTOREALITY ARE FREE OF
                VIRUSES OR OTHER HARMFUL COMPONENTS.
              </p>
              <p>
                TO THE FULL EXTENT PERMISSIBLE BY LAW, BACKTOREALITY WILL NOT BE
                LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF ANY
                BACKTOREALITY SERVICE, OR FROM ANY INFORMATION, CONTENT,
                MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES
                INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH ANY
                BACKTOREALITY SERVICE, INCLUDING, BUT NOT LIMITED TO DIRECT,
                INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES,
                UNLESS OTHERWISE SPECIFIED IN WRITING.
              </p>
            </div>
            <div className="text-section">
              <h2>9. Indemnification</h2>
              <p>
                You agree to indemnify, defend, and hold harmless BackToReality,
                its officers, directors, employees, agents, licensors, and
                suppliers from and against all losses, expenses, damages, and
                costs, including reasonable attorneys' fees, resulting from any
                violation of these Terms or any activity related to your account
                (including negligent or wrongful conduct) by you or any other
                person accessing the Services using your account.
              </p>
            </div>
            <div className="text-section">
              <h2>10. Governing Law and Jurisdiction</h2>
              <p>
                These Terms shall be governed by and construed in accordance
                with the laws of the Grand Duchy of Luxembourg, without regard
                to its conflict of law principles. You agree to submit to the
                exclusive jurisdiction of the courts located in Luxembourg City,
                Luxembourg to resolve any dispute arising out of these Terms or
                the Services.
              </p>
            </div>
            <div className="text-section">
              <h2>11. Severability</h2>
              <p>
                If any provision of these Terms is found to be unlawful, void,
                or for any reason unenforceable, then that provision shall be
                deemed severable from these Terms and shall not affect the
                validity and enforceability of any remaining provisions.
              </p>
            </div>
            <div className="text-section">
              <h2>12. Entire Agreement</h2>
              <p>
                These Terms constitute the entire agreement between you and
                BackToReality regarding your use of the Services and supersede
                all prior or contemporaneous communications and proposals,
                whether oral or written, between you and BackToReality.
              </p>
            </div>
            <div className="text-section">
              <h2>13. Contact Information</h2>
              <p>
                If you have any questions about these Terms, please contact us
                at support@backtoreality.com .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
